<template>
  <div>
    <div class="row">
      <div class="col-md-5">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="laccounts-organization-name" class="control-label">Organization Name:</label>
              <input id="laccounts-organization-name" type="text" class="form-control" v-model="accounts.organizationName" readonly="readonly">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="laccounts-activation-date" class="control-label">Activation Date:</label>
              <date-picker v-model="activationDate"
                           id="laccounts-activation-date"
                           :disabled="true"
                           lang="en"
                           :value-type="'format'"
                           :confirm="false"
                           prefix-class="xmx"
                           :format="calendarFormat">
              </date-picker>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="laccounts-system-id" class="control-label">System ID:</label>
              <input id="laccounts-system-id" type="text" class="form-control" v-model="accounts.systemId" readonly="readonly">
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="laccounts-parent-account" class="control-label">Parent Account:</label>
              <input id="laccounts-parent-account" type="text" class="form-control" value="Yes" readonly="readonly">
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>

    <div class="portlet-body" style="padding-top: 12px">
      <!-- HACK: prevents autocomplete in the filter input -->
      <form autocomplete="off" @submit.prevent>
        <vue-good-table
            :columns="columns"
            :rows="childrenAccounts"
            :pagination-options="{enabled: true}"
            v-if="childrenAccounts.length"
        >
          <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'organizationName'">
                      <a :href="$router.resolve({name:'Manage Account Edit CaseMGR', params: {casemgrid: props.row.id}}).href">{{props.row.organizationName}}</a>
                    </span>
            <span v-else-if="props.column.field == 'activationDate.date'">
                      {{ props.row.activationDate.date | formatDateModalNoTimeZone }}
                    </span>
            <span v-else-if="props.column.field == 'action'">
                      <button :disabled="props.row.isHistorical" class="btn btn-sm green" @click.prevent="showUnlinkAccountModal(props.row.id)">Unlink</button>
                  </span>
            <span v-else>{{props.formattedRow[props.column.field]}}</span>
          </template>
        </vue-good-table>
        <div class="not-found-results" v-else>
          <h4>Sorry, no search results were found.</h4>
        </div>
      </form>
      <div class="clearfix"></div>
      <div style="margin-top:20px">
        <a class="btn green pull-right" :href="$router.resolve({name: 'Add child account', params: { parentid: accounts.id }}).href">Create Child Account</a>
      </div>
      <div class="clearfix"></div>
    </div>

    <div id="unlink-account-modal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <h4 class="modal-title">UNLINK ACCOUNT</h4></div>
          <div class="modal-body">
            <p>Are you sure you would like to permanently unlink this account?</p>
            <p><strong>NOTE: </strong>This change cannot be undone.</p>
          </div>
          <div class="modal-footer">
            <button class="btn green enable-linked-accounts-tab-btn" @click.prevent="unlinkAccountConfirmEnterPasswordModalShow" data-style="expand-left">Yes</button>
            <button class="btn default" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

    <div id="unlink-confirm-password-modal" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
            <h4 class="modal-title">Enter password</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="control-label">Enter your password to unlink this account.</label>
              <input type="password" placeholder="" class="form-control" v-model="confirmUnlinkPassword">
              <span v-show="wrongConfirmUnlinkPassword" class="error-msg help-block">The password you have entered is incorrect</span>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn green mt-ladda-btn ladda-button unlink-account-password-ok-button" @click.prevent="unlinkAccountConfirm">
              <span class="ladda-label">OK</span>
            </button>
            <button class="btn default" data-dismiss="modal">Cancel</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import DatePicker from 'vue2-datepicker';
  import {HTTP, getUserInfo} from "@/http-common";

  export default {
    data() {
      return {
        haveResults: false,
        search: '',
        columns: [
          {
            label: 'Account Name',
            field: 'organizationName',
            filterOptions: {enabled: true}
          },
          {
            label: 'System ID',
            field: 'systemId',
            filterOptions: {enabled: true}
          },
          {
            label: 'Account Owner',
            field: 'accountOwner',
            filterOptions: {enabled: true}
          },
          {
            label: 'Project Contact',
            field: 'projectContact',
            filterOptions: {enabled: true}
          },
          {
            label: 'Activation Date',
            field: 'activationDate.date',
            filterOptions: {enabled: false}
          },
          {
            label: 'Status',
            field: 'status',
            filterOptions: {enabled: true}
          },
          {
            label: 'SMS Status',
            field: 'twilioStatus',
            filterOptions: {enabled: true}
          },
          {
            label: 'Twilio Phone Number',
            field: 'twilioPhone',
            filterOptions: {enabled: true}
          },
          {
            label: 'Action',
            field: 'action',
            filterOptions: {enabled: false}
          }
        ],
        actionAccountId: null,
        confirmUnlinkPassword: '',
        wrongConfirmUnlinkPassword: false
      }
    },
    components: {
      DatePicker
    },
    computed: {
      ...mapGetters({
        logged: 'getUser',
        accounts: 'account',
        user: 'currentUser'
      }),
      calendarFormat() {
        return getUserInfo('date_format');
      },
      childrenAccounts() {
        if (!this.accounts.childrenAccounts) {
          return [];
        }
        let accountsList = this.accounts.childrenAccounts.concat(this.accounts.linkedHistorical);
        return _.map(accountsList, (row) => {
          let status = row.twilioStatus === 1 ? 'Active' : 'Disabled';
          row.twilioStatus = status;
          return row;
        })
      },
      activationDate: {
        get: function () {
          if (this.accounts.activationDate != null) {
            return this.$options.filters.formatDateModal(this.accounts.activationDate['date']);
          }
        },
        set: function () {
        }
      }
    },
    mounted() {
      $('#unlink-confirm-password-modal').on('hidden.bs.modal', () => {
        this.confirmUnlinkPassword = '';
        this.wrongConfirmUnlinkPassword = false;
        this.actionAccountId = null;
      });
    },
    methods: {
      ...mapActions({
        unlinkAccount: 'UNLINK_ACCOUNT_ACTION'
      }),
      showUnlinkAccountModal(accountId) {
        this.actionAccountId = accountId;
        $('#unlink-account-modal').modal('show');
      },
      unlinkAccountConfirmEnterPasswordModalShow() {
        this.confirmUnlinkPassword = '';
        $('#unlink-account-modal').modal('hide');
        $('#unlink-confirm-password-modal').modal('show');
      },
      unlinkAccountConfirm() {
        let loader = Ladda.create(document.querySelector('.unlink-account-password-ok-button'));
        loader.start();
        HTTP.post('/users/checkpassword', {
          'password': this.confirmUnlinkPassword
        }).then((response) => {
          if (response.data.status === 'success') {
            this.wrongConfirmUnlinkPassword = '';
            this.unlinkAccount({id: this.actionAccountId});
            loader.stop();
            $('#unlink-confirm-password-modal').modal('hide');
          } else {
            this.wrongConfirmUnlinkPassword = true;
            loader.stop();
          }
        }).catch((error) => {
          $('#unlink-confirm-password-modal').modal('hide');
          loader.stop();
        });
      }
    }
  }
</script>
<style scoped>
  @media (min-width: 768px) {
    .table.table-light > tbody > tr > td {
      padding: 0px 10px 0px 0px;
    }

    #unlink-account-modal .modal-dialog, #unlink-confirm-password-modal .modal-dialog {
      width: 300px;
    }
  }

  .error-msg {
    color: #f00;
  }

</style>



// WEBPACK FOOTER //
// LinkedAccountsList.vue?02791bda